import React, { useCallback, useContext, useState } from "react";
import GameScoreContext from "./context/GameScore";
import "./Scoreboard.css";
import score from "../img/sactx-1-2048x2048-ETC2-Sprites-ccb1f723 3.png";
import Gamemode from "./Gamemode";
import { localizations, getLanguage } from "./localization";
import GameModeContext from "./context/GameMode";

const Scoreboard = () => {
  const gameScore = useContext(GameScoreContext);
  const [modal, setModal] = useState(false);
  const gameMode = useContext(GameModeContext);
  const closeModal = useCallback(() => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          setModal(false);
        },
        onError: function (error) {},
      },
    });
  }, []);
  const openModal = useCallback(() => {
    setModal(true);
  }, []);
  const reStart = useCallback(() => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          gameMode.actions.setGamemode(new Number(gameMode.state.gamemode));
          gameScore.actions.setGameScore(0);
          setModal(false);
        },
        onError: function (error) {},
      },
    });
  }, [gameMode.actions, gameMode.state.gamemode, gameScore.actions]);
  return (
    <>
      <div className="menu-block">
        <div className="score">
          <img src={score} />
          <span>{gameScore.state.gameScore}</span>
        </div>
        <div className="settings" onClick={openModal}></div>
      </div>
      {modal && (
        <div className="block-modal">
          <div className="block-modal-wrapper">
            <div className="block-modal-title">
              {localizations.resize[getLanguage()]}
            </div>
            <Gamemode onClick={closeModal} />
            <button className="block-modal-button" onClick={closeModal}>
              {localizations.close[getLanguage()]}
            </button>
            <button className="block-modal-button" onClick={reStart}>
              {localizations.restart[getLanguage()]}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Scoreboard);
